import { Column } from 'react-table';

import { formatUnixTimestamp } from '@/shbdeployer/format';
import type { DockerContainer } from '@/docker/containers/types';

export const created: Column<DockerContainer> = {
  Header: 'Создан',
  accessor: 'Created',
  id: 'created',
  Cell: ({ value }) => formatUnixTimestamp(value),
  disableFilters: true,
  canHide: true,
  Filter: () => null,
};
